// extracted by mini-css-extract-plugin
export default {"container":"KSjkjNYl","staticContainer":"M2vxI_ZQ"};